import React, { useState, useMemo, useCallback } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { ContextPanelPlugin } from '@atlaskit/editor-plugin-context-panel';

import type { Item } from './EditorContextPanelContext.ts';
import { EditorContextPanelContext } from './EditorContextPanelContext.ts';

export const EditorContextPanelContextProvider = ({
	children,
	editorAPI,
}: {
	children: React.ReactNode;
	editorAPI: PublicPluginAPI<[ContextPanelPlugin]> | null | undefined;
}): React.JSX.Element => {
	const [item, setItem] = useState<Item | null>(null);

	const setNewItem = useCallback((newItem: Item) => {
		setItem((prevItem) => {
			if (prevItem && prevItem.itemName !== newItem.itemName) {
				prevItem.close();
			}

			return newItem;
		});
	}, []);

	const removeItem = useCallback((itemName: string) => {
		setItem((prevItem) => (prevItem?.itemName === itemName ? null : prevItem));
	}, []);

	const providerValue = useMemo(
		() => ({
			item,
			setItem: setNewItem,
			removeItem,
			editorAPI,
		}),
		[item, removeItem, setNewItem, editorAPI],
	);

	return (
		<EditorContextPanelContext.Provider value={providerValue}>
			{children}
		</EditorContextPanelContext.Provider>
	);
};
